import React from 'react'
import { Controller, UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import StringInput from '../../../../components/inputs/StringInput'
import { MoveOutFormFields } from '../MoveOutWizard'

interface AdditionalDetailsStepProps {
	form: UseFormReturn<MoveOutFormFields>
}

const AdditionalDetailsStep: React.FC<AdditionalDetailsStepProps> = ({ form }) => {
	const { t } = useTranslation('modals_moveOutContact')
	return (
		<div className='flex flex-col gap-4'>
			<div className='text-text-dark dark:text-white text-xs'>
				{t('additionalDetailsStep.description')}
			</div>

			<Controller
				control={form.control}
				name={'additionalDetails'}
				defaultValue=''
				render={({ field }) => (
					<StringInput
						value={field.value}
						onChange={field.onChange}
						multiline
						multilineRows={4}
						label={t('additionalDetailsStep.additionalDetails')}
					/>
				)}
			/>
		</div>
	)
}

export default AdditionalDetailsStep
